export default __webpack_public_path__ + "static/marketing-4349e70d38c5008ee1e3128115decb37.jpg";